import React from "react";
import Astra_Admin_Icons from "@Common/block-icons";
import { __ } from '@wordpress/i18n';
import { getAction, triggerAction } from '@Utils/extensions';

const UsefulPlugins = () => {

	const handlePluginActionTrigger = ( e ) => triggerAction( e );

	const getStatusClass = (value) => {
		if (value === "activated") {
			return "text-[#4AB866] pointer-events-none";
		} else {
			return "text-astra";
		}
	};

	return (
		<div>
			{astra_admin.useful_plugins.map((plugin, key) => (
				<div
					className={`${plugin.status === 'activated' ? '' : 'hover:bg-[#F8FAFC] hover:shadow-hover'} flex justify-between items-start p-4 border-t border-slate-200 bg-white transition `}
					key={key}
				>
					<div className="flex flex-grow">
						<div>
							{ plugin.logoPath.internal_icon && Astra_Admin_Icons[ plugin.logoPath.icon_path ] }
							{ ! plugin.logoPath.internal_icon && <img src={ plugin.logoPath.icon_path } width="40px" height="40px" /> }
						</div>
						<div className="ml-2.5 flex-grow">
							<div className="flex gap-1 justify-between">
								<div className="text-sm leading-[1.375rem] font-medium text-slate-800">
									{plugin.title}
								</div>
								<button
									data-slug={plugin.slug}
									data-init={plugin.path}
									data-redirection={plugin.redirection}
									data-action={getAction(plugin.status)}
									className={` ${getStatusClass(
										plugin.status
									)} p-0 m-0 inline-flex items-center capitalize text-sm leading-4 font-medium cursor-pointer`}
									onClick={ handlePluginActionTrigger }
								>
									{ 'installed' == plugin.status ? astra_admin.plugin_activate_text : plugin.status }
								</button>
							</div>
							<p className="text-sm leading-[1.375rem] text-slate-400">
								{plugin.subtitle}
							</p>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default UsefulPlugins;
